import { render, staticRenderFns } from "./CarouselBackground.vue?vue&type=template&id=ba5682c4&scoped=true&"
import script from "./CarouselBackground.vue?vue&type=script&lang=js&"
export * from "./CarouselBackground.vue?vue&type=script&lang=js&"
import style0 from "./CarouselBackground.vue?vue&type=style&index=0&id=ba5682c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5682c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
